import { cloneDeep, forEach } from 'lodash';
import {
  all,
  call,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';

import {
  listingApi,
} from '../../api';
import {
  errorHandler, successHandler,
} from '../../libs/ga';

import {
  CATEGORY,
} from './constants';

function* storeCategory(data = {}, merge = true) {
  yield put({
    type: CATEGORY.update,
    data,
    merge,
  });
}

function* fetchCategory({
  data,
}) {
  yield* storeCategory(data);
}

function* updateCategory({
  data, onSuccess,
}) {
  try {
    const {
      _id,
      ...rest
    } = data;
    let id = _id;
    if (id) {
      yield call(() => new Promise((resolve, reject) => {
        listingApi.update({
          collection: 'category',
          payload: {
            _id,
            data: rest,
          },
        }).then(() => resolve(true))
          .catch((error) => reject(error));
      }));
      yield* storeCategory({
        [data._id]: data,
      });
    } else {
      const {
        newData,
      } = yield call(() => new Promise((resolve, reject) => {
        listingApi.create({
          collection: 'category',
          payload: {
            data,
          },
        }).then((res) => resolve(res.data))
          .catch((err) => reject(err));
      }));
      id = newData._id;
      yield* storeCategory({
        [newData._id]: newData,
      });
    }
    successHandler('Thành công', 'Cập nhật thành công', onSuccess(id));
  } catch (error) {
    yield* storeCategory();
    errorHandler('Thất bại', error);
  }
}

function* removeCategory({
  _id,
}) {
  const {
    category,
  } = yield select();
  try {
    yield call(() => new Promise((resolve, reject) => {
      listingApi.remove({
        collection: 'category',
        payload: {
          _id,
        },
      }).then(() => resolve(true))
        .catch((error) => reject(error));
    }));

    const newData = cloneDeep(category.data);
    delete newData[_id];
    yield* storeCategory(newData, false);

    successHandler('Thành công', 'Xóa thành công');
  } catch (error) {
    yield* storeCategory();
    errorHandler('Thất bại', error);
  }
}

function* importCategory({
  data = [],
}) {
  yield call(() => new Promise((resolve, reject) => {
    listingApi.importData({
      collection: 'category',
      payload: {
        data,
      },
    }).then(() => resolve(true))
      .catch((err) => reject(err));
  }));
  const {
    category,
  } = yield select();
  const newData = cloneDeep(category.data);
  forEach(data,
    (obj) => {
      newData[obj._id] = obj;
    });
  yield* storeCategory(newData);
  successHandler('Thành công', 'Cập nhật thành công');
}

export default function* categorySaga() {
  yield all([
    yield takeEvery(CATEGORY.handlers.fetch, fetchCategory),
    yield takeEvery(CATEGORY.handlers.update, updateCategory),
    yield takeEvery(CATEGORY.handlers.import, importCategory),
    yield takeEvery(CATEGORY.handlers.remove, removeCategory),
  ]);
}
